import { createGuard } from '@24i/nxg-core-utils/src/guards';
import * as t from 'io-ts';

export const ValidPinGuard = createGuard('ValidPin', {
    isPinCodeValid: t.boolean,
});

export type ValidPin = t.TypeOf<typeof ValidPinGuard>;
